import { useEffect, useRef } from 'react';

// The door's figures, all cut from ONE artwork: the convergence mark (the
// shell's `integrations` figure, the same string art portals.oS wears) —
// 120 trajectories collapsing toward a centre of mass. Each phase of the door
// shows that mark in a different state: drawing itself, broken into fragments
// scattered around the sources they came from, flying back together, held
// inside the boundary you set, and whole again around a nucleus.
//
// Same engine as refractions' marks: an SVG the component owns, rebuilt per
// animation frame from plain numbers, with the scroll handed in through a
// progress ref so no React render rides the scroll. A figure whose phase
// layer is fully faded skips its frame.

const SVG_NS = 'http://www.w3.org/2000/svg';

// the shell's CONVERGENCE_PATH (anatomy/templates/AppMarks.jsx), verbatim
const CONVERGENCE_PATH = 'M126.4 43.3L105.6 88M159 145.5L118.9 114.6M125.8 20.7L103.8 88.4M43.7 40.2L86.1 85.3M113.6 25.2L105.8 68M20.8 67.3L67.8 86.7M178.5 91.1L114.5 98.4M171.3 59.6L123.4 86.7M134.2 30L109.7 80.2M179.5 73.5L116 94.7M99.9 37.6L100 83.9M49.5 31L84.3 78.5M120.3 171L101.1 103.7M176.5 67.4L107.9 96.7M148 145.5L121.6 120.5M129.2 47.2L106.4 88.4M136.5 169.7L105.9 111.4M156.2 125.3L123.2 110.5M171.4 74.4L114.3 94.9M127.9 184.4L105.4 116.2M89.9 26.7L99.3 94.8M166.7 153L109.5 107.6M44.6 143.9L94.6 104.3M147.9 34.8L105 93.2M110.2 172L103.2 122.3M31.5 85.7L95 99M45.4 68.4L94.9 97M15.6 105.4L84.1 101M167.6 123.9L122.4 107.9M165.4 124.5L120.3 107.6M81.7 169.6L95.1 118.7M41.3 34.6L95.1 94.5M174.2 119L121.3 105.4M50.4 160L94.5 106.6M97.6 25.1L99.5 84.4M176 118.7L122.7 105.6M167 95.1L126 98.1M159.5 119.9L125.9 108.7M75.7 165.2L98.3 104.6M156.6 50.4L112.4 89.1M148.5 151.3L115.6 116.5M28.5 69.8L80.7 91.8M81 172.1L93.5 124.6M17.8 70.4L69.7 89.1M39.9 109.9L95.7 100.7M88.3 11.4L97.6 82.1M56.4 47.9L97.3 96.7M35.9 119.7L82.6 105.3M111.3 159.2L104.4 123.3M42 56.7L79.7 84.8M177 129.4L107.4 102.8M33.2 115.1L87.9 102.7M165.1 107.2L110.6 101.2M65.7 173.1L90.4 120.4M187 79.2L120.7 95.1M119.6 157.1L105.2 115M171.7 133.9L112.3 105.8M20.8 129L93.3 102.5M43.9 127.9L86.9 106.5M149.7 52.6L121.5 79.5M17 84.5L86.8 97.5M86.1 23.5L97.6 86.9M136.2 156.6L104.8 107.5M134.4 31.2L103.8 92.3M56.7 43.1L87.5 83.6M78.5 30.6L96.7 89.4M150.7 66.2L120 86.7M55.2 29.5L83.2 73.5M144.9 152.7L116 118.8M34 93L78.5 97.7M151.3 61.5L122 83.5M90.6 20.7L98.2 84.8M154 56.9L117.2 86.2M173.9 106.9L119.4 101.8M151.4 164L121 126.2M83 40.1L97.3 90.4M93.8 162.1L97.9 121M75.3 40.2L96.7 92M172.9 50.7L108.8 94.1M147.8 51.3L103.4 96.6M60.1 177.5L83.7 131.6M170.4 61.2L110.9 94M152.7 57.7L116.9 86.5M169.3 98.4L120.6 99.5M163.1 109.1L120.1 102.9M166 119.4L124.8 107.3M101.1 20.3L100.3 81M175.1 69.6L124 90.3M67.2 16.9L93 82.3M170.8 109.9L116.8 102.3M100 24L100 77.7M30.2 103.5L78.3 101.1M93.3 167.4L99 110.3M100.3 30.3L100.1 88.4M161.6 83.9L108 97.9M42.4 42.8L91.8 91.9M125.5 161.7L106.3 115.3M125.3 45.1L101.9 95.9M28.6 86.3L79.2 96M108.9 167.5L103.3 125.4M174.6 50.6L105 96.7M144.7 147.8L104.2 104.5M96.5 33.4L98.7 74.8M151.7 131.9L105 103.1M29.1 45L85.2 88.5M34.7 147L86.8 109.5M60 172.4L94.6 109.8M69.2 165.6L93.9 112.9M102.2 34.1L100.9 72.2M37.3 78L87.8 95.7M84.4 158.8L94.9 119.1M154.7 131.9L121.3 112.5M164.6 150.9L106.7 105.3M157.2 44.4L119.2 81.3M144.6 161L109.1 112.4M16.4 81L93.5 98.5M37.1 104.5L88.5 100.8M25.8 86.9L85.5 97.4M90.4 179.5L97.9 117.3M48.4 147.9L81.7 117';

// The sources the scattered phase names — what the plugins and the phone
// actually read today, in plain words.
export const SOURCES = [
  'gmail', 'calendar', 'contacts', 'drive', 'github', 'spotify', 'youtube',
  'chess.com', 'lichess', 'sleep', 'heart rate', 'steps', 'workouts', 'voice notes',
];

function smoothstep(t) { t = Math.max(0, Math.min(1, t)); return t * t * (3 - 2 * t); }
const clamp01 = (t) => Math.max(0, Math.min(1, t));
const f = (n) => n.toFixed(2);

// deterministic randomness, so every figure agrees on the same scatter
function rng(seed) {
  return () => {
    seed |= 0; seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// The mark's segments, normalised the way the shell's markGeometry boxes it
// (ink bounds, squared, padded 6%) and centred on 0: coordinates in ~±0.47.
// Every segment is stored OUTER end first, so "drawing toward the centre"
// always runs o → i.
const SEGMENTS = (() => {
  const nums = CONVERGENCE_PATH.split(/[ML ]/).filter(Boolean).map(Number);
  const raw = [];
  for (let k = 0; k + 3 < nums.length; k += 4) raw.push([nums[k], nums[k + 1], nums[k + 2], nums[k + 3]]);
  let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
  for (const [ax, ay, bx, by] of raw) {
    x0 = Math.min(x0, ax, bx); x1 = Math.max(x1, ax, bx);
    y0 = Math.min(y0, ay, by); y1 = Math.max(y1, ay, by);
  }
  const side = Math.max(x1 - x0, y1 - y0) * 1.06;
  const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
  const rand = rng(7);
  return raw.map(([ax, ay, bx, by]) => {
    let a = [(ax - cx) / side, (ay - cy) / side];
    let b = [(bx - cx) / side, (by - cy) / side];
    if (Math.hypot(...a) < Math.hypot(...b)) [a, b] = [b, a];
    return {
      ox: a[0], oy: a[1], ix: b[0], iy: b[1],
      ang: Math.atan2(a[1], a[0]),
      len: Math.hypot(a[0] - b[0], a[1] - b[1]),
      seed: rand(),
    };
  });
})();

// the order the hero draws in: a sweep around the mark, clockwise from the top
const SWEEP = SEGMENTS.map((s, k) => [k, (s.ang + Math.PI * 2.5) % (Math.PI * 2)])
  .sort((a, b) => a[1] - b[1]).map(([k]) => k);
const SWEEP_RANK = new Array(SEGMENTS.length);
SWEEP.forEach((k, r) => { SWEEP_RANK[k] = r; });

// ── THE SCATTER — one layout, read by two phases ─────────────────────────────
// Where each source label stands, and where each fragment of the mark lies
// before it converges: clustered around the source it belongs to, rotated,
// shortened. Scattered and converging phases compute the SAME layout for a
// block of the same size, so the hand-off between them reads as one motion.
function scatterLayout(W, H) {
  const rand = rng(31);
  const minD = Math.min(W, H);
  const cx = W / 2, cy = H / 2;
  const mx = Math.max(56, W * 0.12), my = Math.max(36, H * 0.1);
  // labels keep clear of each other: a few candidate seats per source, the
  // first that doesn't crowd a placed label wins (else the roomiest one)
  const placed = [];
  const crowd = (x, y) => placed.reduce((m, q) => Math.min(m, Math.max(Math.abs(x - q[0]) / 110, Math.abs(y - q[1]) / 30)), Infinity);
  const labels = SOURCES.map((name, i) => {
    let best = null;
    for (let t = 0; t < 24; t++) {
      const a = i * 2.39996 + (t === 0 ? 0 : rand() * Math.PI * 2) + rand() * 0.5;
      const r = minD * (0.2 + rand() * 0.24);
      const cxy = [
        Math.min(W - mx, Math.max(mx, cx + Math.cos(a) * r * (W / minD) * 0.95)),
        Math.min(H - my, Math.max(my, cy + Math.sin(a) * r * (H / minD) * 0.95)),
      ];
      const room = crowd(...cxy);
      if (!best || room > best[1]) best = [cxy, room];
      if (room >= 1) break;
    }
    const [x, y] = best[0];
    placed.push([x, y]);
    return {
      name, x, y,
      right: x < cx, // the label reads away from the centre
      ax: minD * (0.008 + rand() * 0.01), ay: minD * (0.008 + rand() * 0.01),
      wx: 0.00016 + rand() * 0.0002, wy: 0.00016 + rand() * 0.0002,
      px: rand() * Math.PI * 2, py: rand() * Math.PI * 2,
    };
  });
  const frags = SEGMENTS.map((s, k) => {
    const host = labels[k % labels.length];
    const a = rand() * Math.PI * 2;
    const d = minD * (0.025 + rand() * 0.07);
    const rot = rand() * Math.PI * 2;
    const h = (s.len * minD * 0.78 * 0.45) / 2;
    return { host, dx: Math.cos(a) * d, dy: Math.sin(a) * d, cos: Math.cos(rot) * h, sin: Math.sin(rot) * h };
  });
  return { labels, frags };
}

function wander(l, elapsed) {
  return [l.x + l.ax * Math.sin(l.wx * elapsed + l.px), l.y + l.ay * Math.sin(l.wy * elapsed + l.py)];
}

function labelSvg(l, x, y, op) {
  const tx = l.right ? x + 9 : x - 9;
  return `<circle cx="${f(x)}" cy="${f(y)}" r="2.4" fill="currentColor" opacity="${(0.85 * op).toFixed(3)}"/>`
    + `<text x="${f(tx)}" y="${f(y + 3.5)}" text-anchor="${l.right ? 'start' : 'end'}" opacity="${(0.72 * op).toFixed(3)}">${l.name}</text>`;
}

// ── the shared stage: an owned SVG, sized to its host, redrawn per frame ─────
function useFigure(draw) {
  const hostRef = useRef(null);
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return undefined;
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', 'ig-figure');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    host.appendChild(svg);
    const box = { W: 600, H: 600 };
    const size = () => {
      const r = host.getBoundingClientRect();
      box.W = r.width || 600; box.H = r.height || 600;
      svg.setAttribute('viewBox', `0 0 ${box.W} ${box.H}`);
    };
    size();
    const ro = new ResizeObserver(size);
    ro.observe(host);
    const layer = host.closest('.ig-door__layer');
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const state = {};
    const t0 = performance.now();
    let raf = 0;
    const tick = (now) => {
      raf = requestAnimationFrame(tick);
      if (layer && layer.style.opacity !== '' && parseFloat(layer.style.opacity) === 0) return;
      svg.innerHTML = draw({ W: box.W, H: box.H, elapsed: now - t0, reduce, state });
    };
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); ro.disconnect(); svg.remove(); };
  }, []);
  return hostRef;
}

// a scroll-fed value that eases toward its target instead of snapping
function chase(state, key, target, rate = 0.09) {
  const v = state[key] ?? target;
  const next = Math.abs(target - v) < 0.0005 ? target : v + (target - v) * rate;
  state[key] = next;
  return next;
}

// The mark's own strokes at scale S around (cx, cy). `drawn(k)` says how much
// of segment k stands (0..1, from the outer end in); the flow is a short
// brighter pulse running each trajectory toward the centre, forever.
function markSvg({ cx, cy, S, drawn, elapsed, reduce, base = 0.42, flow = true }) {
  let html = '';
  for (let k = 0; k < SEGMENTS.length; k++) {
    const t = drawn(k);
    if (t <= 0) continue;
    const s = SEGMENTS[k];
    const ox = cx + s.ox * S, oy = cy + s.oy * S;
    const ix = cx + s.ix * S, iy = cy + s.iy * S;
    const ex = ox + (ix - ox) * t, ey = oy + (iy - oy) * t;
    html += `<line x1="${f(ox)}" y1="${f(oy)}" x2="${f(ex)}" y2="${f(ey)}" stroke-opacity="${base}"/>`;
    if (!flow || reduce || t < 1) continue;
    // the pulse: a 22%-long highlight gliding outer → inner, each on its own clock
    const u = ((elapsed / 3400) + s.seed) % 1;
    const a = Math.max(0, u - 0.22), b = u;
    const fade = Math.sin(Math.PI * u);
    html += `<line x1="${f(ox + (ix - ox) * a)}" y1="${f(oy + (iy - oy) * a)}" x2="${f(ox + (ix - ox) * b)}" y2="${f(oy + (iy - oy) * b)}" stroke-width="1.3" stroke-opacity="${(0.9 * fade).toFixed(3)}"/>`;
  }
  return html;
}

// ── 1. THE MARK ARRIVES — draws itself in a clockwise sweep on load, then the
// trajectories keep flowing inward. With a nucleusRef (the close), a solid
// centre grows as the reader descends: what all of it was converging on.
export function ConvergenceMark({ nucleusRef }) {
  const ref = useFigure(({ W, H, elapsed, reduce, state }) => {
    const S = Math.min(W, H) * 0.8;
    const cx = W / 2, cy = H / 2;
    const clock = reduce ? 1e9 : elapsed;
    let html = markSvg({
      cx, cy, S, elapsed, reduce,
      drawn: (k) => smoothstep((clock - 120 - SWEEP_RANK[k] * 11) / 520),
    });
    if (nucleusRef) {
      const n = smoothstep(chase(state, 'n', clamp01(nucleusRef.current || 0)) * 1.4);
      if (n > 0) {
        const r = S * 0.018 * n;
        html += `<circle cx="${f(cx)}" cy="${f(cy)}" r="${f(r * 3.2)}" fill="none" stroke-opacity="${(0.25 * n).toFixed(3)}"/>`;
        html += `<circle cx="${f(cx)}" cy="${f(cy)}" r="${f(r)}" fill="currentColor" stroke="none" opacity="${(0.9 * n).toFixed(3)}"/>`;
      }
    }
    return html;
  });
  return <div ref={ref} className="ig-figure-host" />;
}

// ── 2. SCATTERED — the sources surface one by one as the reader descends,
// each trailing the fragments of the mark that belong to it.
export function ScatterMark({ progressRef }) {
  const ref = useFigure(({ W, H, elapsed, reduce, state }) => {
    if (!state.layout || state.W !== W || state.H !== H) {
      state.layout = scatterLayout(W, H); state.W = W; state.H = H;
    }
    const { labels, frags } = state.layout;
    const n = labels.length;
    const clock = reduce ? 0 : elapsed;
    // a few stand from the first frame; the rest arrive by 80% of the phase
    const shown = chase(state, 's', 3 + clamp01((progressRef.current || 0) / 0.8) * (n - 3));
    const pos = labels.map((l) => wander(l, clock));
    let html = '';
    frags.forEach((fr) => {
      const i = labels.indexOf(fr.host);
      const op = smoothstep(shown - i);
      if (op <= 0) return;
      const [hx, hy] = pos[i];
      const mx = hx + fr.dx, my = hy + fr.dy;
      html += `<line x1="${f(mx - fr.cos)}" y1="${f(my - fr.sin)}" x2="${f(mx + fr.cos)}" y2="${f(my + fr.sin)}" stroke-opacity="${(0.38 * op).toFixed(3)}"/>`;
    });
    labels.forEach((l, i) => {
      const op = smoothstep(shown - i);
      if (op > 0) html += labelSvg(l, pos[i][0], pos[i][1], op);
    });
    return html;
  });
  return <div ref={ref} className="ig-figure-host" />;
}

// ── 3. CONVERGING — every fragment leaves its source and flies to its seat in
// the mark; the scroll is the pull. The labels fade as their fragments go.
export function ConvergeMark({ progressRef }) {
  const ref = useFigure(({ W, H, elapsed, reduce, state }) => {
    if (!state.layout || state.W !== W || state.H !== H) {
      state.layout = scatterLayout(W, H); state.W = W; state.H = H;
    }
    const { labels, frags } = state.layout;
    const clock = reduce ? 0 : elapsed;
    // arrive whole by 85% of the phase, so the finished mark gets a beat
    const p = chase(state, 'p', clamp01((progressRef.current || 0) / 0.85), 0.08);
    const S = Math.min(W, H) * 0.8;
    const cx = W / 2, cy = H / 2;
    // the wander stills as the pull takes hold
    const pos = labels.map((l) => {
      const [wx, wy] = wander(l, clock);
      return [l.x + (wx - l.x) * (1 - p), l.y + (wy - l.y) * (1 - p)];
    });
    let html = '';
    SEGMENTS.forEach((s, k) => {
      const fr = frags[k];
      const [hx, hy] = pos[labels.indexOf(fr.host)];
      const mx = hx + fr.dx, my = hy + fr.dy;
      // staggered: each fragment leaves on its own beat within the pull
      const t = smoothstep((p - s.seed * 0.45) / 0.55);
      const tx1 = cx + s.ox * S, ty1 = cy + s.oy * S;
      const tx2 = cx + s.ix * S, ty2 = cy + s.iy * S;
      const x1 = (mx - fr.cos) + (tx1 - (mx - fr.cos)) * t;
      const y1 = (my - fr.sin) + (ty1 - (my - fr.sin)) * t;
      const x2 = (mx + fr.cos) + (tx2 - (mx + fr.cos)) * t;
      const y2 = (my + fr.sin) + (ty2 - (my + fr.sin)) * t;
      html += `<line x1="${f(x1)}" y1="${f(y1)}" x2="${f(x2)}" y2="${f(y2)}" stroke-opacity="${(0.38 + 0.06 * t).toFixed(3)}"/>`;
    });
    const lop = 1 - smoothstep(p / 0.45);
    if (lop > 0) labels.forEach((l, i) => { html += labelSvg(l, pos[i][0], pos[i][1], lop); });
    return html;
  });
  return <div ref={ref} className="ig-figure-host" />;
}

// ── 4. THE BOUNDARY — the mark held inside a ring you draw. Traffic arrives
// from every direction and stops at the ring; only the doors you open (the
// gates, lit one by one as the reader descends) let it through to the centre.
const SPOKES = 18;
const GATES = [1, 6, 10, 15];
export function BoundaryMark({ progressRef }) {
  const ref = useFigure(({ W, H, elapsed, reduce, state }) => {
    const p = chase(state, 'p', clamp01(progressRef.current || 0));
    const minD = Math.min(W, H);
    const cx = W / 2, cy = H / 2;
    const R = minD * 0.3;
    const S = R * 1.55;
    const clock = reduce ? 0 : elapsed;
    let html = markSvg({ cx, cy, S, elapsed, reduce, base: 0.2, flow: false, drawn: () => 1 });
    // the ring draws itself over the phase's first half
    const ring = smoothstep(p / 0.45);
    const C = 2 * Math.PI * R;
    html += `<circle cx="${f(cx)}" cy="${f(cy)}" r="${f(R)}" fill="none" stroke-width="1.2" stroke-opacity="0.75" stroke-dasharray="${f(C * ring)} ${f(C)}" transform="rotate(-90 ${f(cx)} ${f(cy)})"/>`;
    // then the gates open, one after another
    const open = GATES.map((_, g) => smoothstep((p - 0.45 - g * 0.1) / 0.12));
    const far = Math.hypot(W, H) / 2;
    for (let sIdx = 0; sIdx < SPOKES; sIdx++) {
      const a = (sIdx / SPOKES) * Math.PI * 2 - Math.PI / 2 + 0.09;
      const ca = Math.cos(a), sa = Math.sin(a);
      const g = GATES.indexOf(sIdx);
      const go = g >= 0 ? open[g] : 0;
      const r0 = far, r1 = R + 3;
      html += `<line x1="${f(cx + ca * r0)}" y1="${f(cy + sa * r0)}" x2="${f(cx + ca * r1)}" y2="${f(cy + sa * r1)}" stroke-opacity="${(0.14 + 0.16 * go).toFixed(3)}" stroke-dasharray="2 5"/>`;
      if (go > 0) {
        // an open gate: a bracket in the ring, and a line through to the centre
        const gx = cx + ca * R, gy = cy + sa * R;
        const px = -sa * 7, py = ca * 7;
        html += `<line x1="${f(gx - px)}" y1="${f(gy - py)}" x2="${f(gx + px)}" y2="${f(gy + py)}" stroke-width="2.4" stroke-opacity="${(0.9 * go).toFixed(3)}"/>`;
        const rin = R * (1 - 0.82 * go);
        html += `<line x1="${f(gx)}" y1="${f(gy)}" x2="${f(cx + ca * rin)}" y2="${f(cy + sa * rin)}" stroke-opacity="${(0.55 * go).toFixed(3)}"/>`;
      }
      if (reduce) continue;
      // a packet on its way in: it halts and fades at a closed ring, or runs
      // on to the centre through an open gate
      const u = ((clock / 2600) + sIdx * 0.137) % 1;
      const through = go > 0.5;
      const rEnd = through ? R * 0.12 : R + 3;
      const r = r0 * 0.62 + (rEnd - r0 * 0.62) * u;
      const op = through ? Math.sin(Math.PI * u) : Math.min(1, u * 3) * (1 - smoothstep((u - 0.75) / 0.25));
      html += `<circle cx="${f(cx + ca * r)}" cy="${f(cy + sa * r)}" r="${through ? 2.2 : 1.7}" fill="currentColor" stroke="none" opacity="${(op * (through ? 0.9 : 0.5) * ring).toFixed(3)}"/>`;
    }
    return html;
  });
  return <div ref={ref} className="ig-figure-host" />;
}
